const adminControlRoutes = [
    {
        path: "/admin/common-cloud-storage",
        name: "commoncloudstorage",
        component: () => import("@/views/Pages/Admin Controls/CommonCloudStorage.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/blocked-domains",
        name: "blockeddomains",
        component: () => import("@/views/Pages/Admin Controls/BlockedDomains.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/cached-domains",
        name: "cacheddomains",
        component: () => import("@/views/Pages/Admin Controls/CachedDomains.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/reported-websites",
        name: "adminreportedwebsites",
        component: () => import("@/views/Pages/Admin Controls/ReportedWebsites.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/admin-reports",
        name: "adminreports",
        component: () => import("@/views/Pages/Admin Controls/AdminReports.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/password-websites",
        name: "passwordwebsites",
        component: () => import("@/views/Pages/Admin Controls/PasswordWebsites.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/unsafe-websites",
        name: "unsafewebsites",
        component: () => import("@/views/Pages/Admin Controls/UnsafeWebsites.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/cron-jobs",
        name: "cronjobs",
        component: () => import("@/views/Pages/Admin Controls/CronJobs.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/allocate-extension-keys",
        name: "extensionkeyallocation",
        component: () => import("@/views/Pages/Admin Controls/ExtensionKeyAllocation.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/ai-categories",
        name: "aicategories",
        component: () => import("@/views/Pages/Admin Controls/AiCategories.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/government-tlds",
        name: "governmenttlds",
        component: () => import("@/views/Pages/Admin Controls/GovernmentTlds.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/debugger",
        name: "debugger",
        component: () => import("@/views/Pages/Admin Controls/DebuggerModule.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    // {
    //     path: "/admin/insights",
    //     name: "insights",
    //     component: () => import("@/views/Pages/Admin Controls/ExtensionKeyAllocation.vue"),
    // },
]

export default adminControlRoutes